import axios from 'axios';
import API_V2_URL from '@/constants/API_V2_URL';

const DispatchService = {
  all({page, limit, q}) {
    return axios.get(`${ API_V2_URL() }/system/dispatches?page=${ page }&limit=${ limit }&q=${ q }`);
  },
  async show(id) {
    return (await axios.get(`${ API_V2_URL() }/system/dispatches/${ id }`)).data;
  },
  createOrUpdate({id, title, administrativeUnitIds, text}) {
    const payload = {
      title,
      administrative_unit_ids: administrativeUnitIds,
      text
    }
    if (id === '' || id === undefined) {
      return axios.post(`${ API_V2_URL() }/system/dispatches`, {
        dispatch: payload
      })
    } else {
      return axios.patch(`${ API_V2_URL() }/system/dispatches/${ id }`, {
        dispatch: payload
      })
    }
  },
  destroy(id) {
    return axios.delete(`${ API_V2_URL() }/system/dispatches/${ id }`);
  },
  async dispatches(administrativeUnitId) {
    return (await axios.get(`${ API_V2_URL() }/system/administrative_units/${ administrativeUnitId }/dispatches`)).data;
  }
};

export default DispatchService;



// WEBPACK FOOTER //
// ./src/services/system/DispatchService.js